/* global BigInt */
// Price changes stay decimal until the server stores qty * price.
export function priceWithPercent(value, percent) {
  const parse = input => {
    const match = String(input || 0).trim().match(/^([+-]?)(\d*)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
    if (!match || (!match[2] && !match[3])) throw new Error("Număr invalid.");
    let scale = (match[3] || "").length - Number(match[4] || 0);
    let digits = BigInt((match[2] || "0") + (match[3] || "")) * (match[1] === "-" ? -1n : 1n);
    if (scale < 0) { digits *= 10n ** BigInt(-scale); scale = 0; }
    return [digits, scale];
  };
  const [price, ps] = parse(value);
  const [change, cs] = parse(percent);
  let amount = price * (100n * 10n ** BigInt(cs) + change);
  let scale = ps + cs + 2;
  const negative = amount < 0n;
  if (negative) amount = -amount;
  if (scale > 12) {
    const divisor = 10n ** BigInt(scale - 12);
    amount = (amount + divisor / 2n) / divisor; scale = 12;
  }
  const digits = amount.toString().padStart(scale + 1, "0");
  const result = scale ? `${digits.slice(0, -scale)}.${digits.slice(-scale)}`.replace(/\.?0+$/, "") : digits;
  return (negative && amount ? "-" : "") + (result || "0");
}
